import Footer from '@/renderer/Footer';
import Header from '@/renderer/Header';
import { usePageContext } from '@/renderer/utils/usePageContext';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/16/solid';

export default ReleaseSchedulePage;

function ReleaseSchedule() {
  const {
    config: { title },
  } = usePageContext();

  return (
    <div className="flex h-40 min-h-[stretch] flex-1 grow flex-col justify-between overflow-hidden">
      <Header title="Release Schedule" className="py-2 sm:hidden" />
      <div className="overflow-auto">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="relative mx-auto hidden max-w-2xl pt-20 pb-24 text-center sm:block">
            <h1 className="font-bold text-3xl text-zinc-900 tracking-tight sm:text-4xl dark:text-zinc-200">
              {typeof title === 'string' ? title : ''}
            </h1>
            <p className="mt-4 text-base text-zinc-600 leading-7 dark:text-zinc-400">
              Last updated on Dec. 12, 2025
            </p>
          </div>
        </div>

        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="prose prose-sm prose-zinc dark:prose-invert mx-auto max-w-prose prose-a:font-semibold prose-a:hover:text-emerald-500">
            <p>Release windows are market dependent and release times may vary.</p>
            <div className="mt-8 space-y-16">
              <div>
                <h4 className="border-zinc-900/5 border-b font-bold text-zinc-500 uppercase dark:border-white/5 dark:text-zinc-400">
                  College basketball
                </h4>
                <div className="mt-4 rounded bg-zinc-50 p-4 ring ring-zinc-950/10 dark:bg-white/5 dark:ring-white/10">
                  <h5 className="mt-2 font-semibold text-sm text-zinc-900 uppercase dark:text-white">
                    Weekdays
                  </h5>
                  <div className="space-y-2">
                    <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                      <dt className="m-0 flex items-baseline space-x-2">
                        <span>First check in</span>
                      </dt>
                      <dd className="p-0">10 a.m. PT</dd>
                    </div>
                    <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                      <dt className="m-0 flex items-baseline space-x-2">
                        <span>
                          Second check in
                          {/* <br />
                        <span className="font-normal">(totals, 1st halves & late sides)</span> */}
                        </span>
                      </dt>
                      <dd className="p-0 md:text-right">2 p.m. PT</dd>
                    </div>
                    <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                      <dt className="m-0 flex items-baseline space-x-2">
                        <span className="font-normal">
                          Additional updates throughout the day as needed. 10+ minute warning before
                          any release
                        </span>
                      </dt>
                    </div>
                  </div>
                </div>
                <div className="mt-4 rounded bg-zinc-50 p-4 ring ring-zinc-950/10 dark:bg-white/5 dark:ring-white/10">
                  <h5 className="mt-2 font-semibold text-sm text-zinc-900 uppercase dark:text-white">
                    Weekends/Holidays
                  </h5>
                  <div className="font-normal">(Or any day with early games)</div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>First check in</span>
                    </dt>
                    <dd className="p-0 md:text-right">7:45 a.m. PT</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Second check in</span>
                    </dt>
                    <dd className="p-0 md:text-right">8:30 a.m. PT</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Third check in</span>
                    </dt>
                    <dd className="p-0 md:text-right">9:45 a.m. PT</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <a
                        href="https://www.youtube.com/@raspicks/streams"
                        target="_blank"
                        rel="noreferrer"
                        className="text-zinc-900 no-underline dark:text-white"
                      >
                        <span className="flex flex-row items-center space-x-2">
                          <span>CBB Release Shows</span>
                          <ArrowTopRightOnSquareIcon className="size-4 shrink-0" />
                        </span>
                      </a>
                    </dt>
                    <dd className="p-0">TBD</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span className="font-normal">
                        Additional updates throughout the day as needed. 10+ minute warning before
                        any release
                      </span>
                    </dt>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-8 space-y-16">
              <div>
                <h4 className="border-zinc-900/5 border-b font-bold text-zinc-500 uppercase dark:border-white/5 dark:text-zinc-400">
                  NFL
                </h4>
                <div className="space-y-2">
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Sides & Totals</span>
                    </dt>
                    <dd className="p-0">Mondays, 7:45-8:15 a.m. PT</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span className="font-normal">
                        Additional updates throughout the week as needed. 10+ minute warning before
                        any release
                      </span>
                    </dt>
                  </div>
                </div>
              </div>
              <div>
                <h4 className="border-zinc-900/5 border-b font-bold text-zinc-500 uppercase dark:border-white/5 dark:text-zinc-400">
                  College football
                </h4>
                <div className="space-y-2">
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Regular season bonus plays</span>
                    </dt>
                    <dd className="p-0">TBD, will be rare, but random times when sent</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>
                        Bowl plays
                        {/* <br />
                        <span className="font-normal">(totals, 1st halves & late sides)</span> */}
                      </span>
                    </dt>
                    <dd className="p-0 md:text-right">Schedule announced in Dec. 2025</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Unplanned releases</span>
                    </dt>
                    <dd className="p-0">Possible with a 10+ minute warning</dd>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

// Main component
function ReleaseSchedulePage() {
  return <ReleaseSchedule />;
}
